// Module
var code = "<uib-accordion close-others=\"{{form.closeOthers}}\" class=\"form-group schema-form-{{form.type}} {{form.htmlClass}}\"> </uib-accordion> ";
// Exports
var _module_exports = code;;
var path = 'app/common/schemaFormUtility/components/addons/templates/ecv-accordion.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;